import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, lastValueFrom,  Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, Validators } from '@angular/forms';
import { Constants,  LEADSOURCE } from '@app/constants';
import { CampaignService } from './campaign.service';
import { ToastService } from './toast/toast.service';
import { TelephonyProvider } from '../providers/telephony/telephony.provider';
import { BundleDealerService } from './bundle-dealer.service';

@Injectable({
  providedIn: 'root',
})
export class ProviderService implements OnInit, OnDestroy {
  //* Decalre ANY Variables HERE
  subscriptions = new Array<Subscription>();

  callCampaignCode: string = '';
  isPGECall = false;
  isPGESpanishCall = false;
  isFPL_NRG_Call = false;
  isFPL_ENG_Call = false;
  isSTAR_LINK_Call = false;
  isZIPLY_Call = false;
  isStarlinkCampaign = false;
  isZIPLYCampaign = false;
  isUSH_Call = false;
  isPortmoreCall = false;
  isPortmoreSpanishCall = false;
  isPKCall = false;
  isDefaultSpanish = false;
  isDefaultEnglish = false;
  isSTAR_LINK_Call_Inbound = false;
  isTikTokCampaign = false;
  metadata$ = new BehaviorSubject<any>({});
  integration = {
    isEnabled: false,
    isHubspotEnabled: false,
  };

  constructor(
    private campaignService: CampaignService,
    private toastService: ToastService,
    private httpClient: HttpClient,
    private fb: FormBuilder,
    private telephony: TelephonyProvider,
    private bdService: BundleDealerService
  ) {
    this.subscriptions.push(
      this.telephony.voice.events.subscribe(async (event) => {
        switch (event.type) {
          case 'Call':
            switch (event.name) {
              case 'accept':
                const {
                  campaignId,
                  callSid,
                  callType,
                  btn,
                  tfn,
                  campaignCode,
                  tfnCampaignCode,
                  campaignName,
                  langCode,
                } = event.data;

                //* Bits Activition
                this.providerBitActivition(btn, tfnCampaignCode, tfn);

                //* Provider Logics
                this.providerLogicSetup(btn, tfnCampaignCode);

                //this.zone.run(() => {
                this.scriptDecider();
                //this.router.navigate(['/agent/calls/campaign']);
                // });

                break;
              case 'dispose':
                this.resetProviderBits();
                break;
            }
            break;
        }
      })
    );
  }

  ngOnInit(): void { }

  providerBitActivition(btn: any, code: any, tfn: any) {
    //* FPL NRG Check Work if call is for FPL
    this.isFPL_NRG_Call = this.campaignService.getScriptSkillCode('FPL_NRG_SKILLCODE').includes(code);
    //* FPL ENG Check Work if call is for FPL
    this.isFPL_ENG_Call = this.campaignService.getScriptSkillCode('FPL_ENGLISH_SKILLCODE').includes(code);
    //* PGE Check Work if call is for PGE
    this.isPGECall = this.campaignService.getScriptSkillCode('PGESKILLCODE').includes(code);
    //* STARLINK Check Work if call is for STARLINK
    this.isSTAR_LINK_Call = this.campaignService.getScriptSkillCode('STAR_LINK_SKILLCODE').includes(code);
    //* ZIPLY Check Work if call is for ZIPLY
    this.isZIPLY_Call = (this.campaignService.getScriptSkillCode('ZIPLY_SKILLCODE') || '').includes(code);
    //* PORTMORE Check Work if call is for PORTMORE
    this.isUSH_Call = this.campaignService.getScriptSkillCode('USH_SKILLCODE').includes(code);
    this.isPortmoreCall = this.campaignService.getScriptSkillCode('PORTMORE_SKILLCODE').includes(code);
    this.isPortmoreSpanishCall = this.campaignService
      .getScriptSkillCode('PORTMORE_DEFAULT_SPANISH_SKILLCODE')
      .includes(code);
    this.isPKCall = this.campaignService.getScriptSkillCode('PK_SKILLCODE').includes(code);
    this.isDefaultEnglish = this.campaignService.getScriptSkillCode('DEFAULT_ENGLISH_SKILLCODE').includes(code);
    this.isDefaultSpanish = this.campaignService.getScriptSkillCode('DEFAULT_SPANISH_SKILLCODE').includes(code);
    this.isSTAR_LINK_Call_Inbound = this.campaignService.getScriptSkillCode('STAR_LINK2_SKILLCODE').includes(code)
    this.isTikTokCampaign = this.campaignService.getScriptSkillCode('TIKTOK_SKILLCODE').includes(code);
  }

  providerLogicSetup(btn: any, code: any) {
    this.callCampaignCode = code;
    this.isPGECall && this.setupPGECall(btn, code);
    this.isSTAR_LINK_Call && this.setupStarLinkCall();
    this.isZIPLY_Call && this.setupZiplyCall();
    this.isUSH_Call && this.setupUSHCall(btn, code);
    this.isPortmoreCall && this.setupPortmoreCall(btn, code);
    this.isPKCall && this.setupPKCall(btn, code);
    this.isSTAR_LINK_Call_Inbound && this.setupStarlinkInboundCall();
  }

  scriptDecider() {
    //* Script Loading Logic
    if (this.isPGECall) {
      if (this.isPGESpanishCall) {
        this.campaignService.scriptName = 'pge-spanish';
      } else {
        this.campaignService.scriptName = 'pge';
      }
    } else if (this.isFPL_NRG_Call) {
      this.campaignService.scriptName = 'default-spanish';
    } else if (this.isSTAR_LINK_Call) {
      this.campaignService.scriptName = 'star-link';
    }
    else if (this.isSTAR_LINK_Call_Inbound) {
      this.campaignService.scriptName = 'star-link2';
    }
    else if (this.isZIPLY_Call) {
      this.campaignService.scriptName = 'ziply';
    } else if (this.isFPL_ENG_Call) {
      this.campaignService.scriptName = 'fpl-english';
    } else if (this.isUSH_Call) {
      //skill code script
      //* E18,E16,E17 change to K18,K16,K17 because it was move to Belize
      if (this.callCampaignCode === 'E18' || this.callCampaignCode === 'K18' || this.callCampaignCode === 'N18' || this.callCampaignCode === 'TS6' || this.callCampaignCode === 'J05') {
        this.campaignService.scriptName = 'ush-e18';
      } else if (this.callCampaignCode === 'E16' || this.callCampaignCode === 'K16' || this.callCampaignCode === 'N16' || this.callCampaignCode === 'TS5' || this.callCampaignCode === 'J03') {
        this.campaignService.scriptName = 'ush-e16';
      } else if (this.callCampaignCode === 'E17' || this.callCampaignCode === 'K17' || this.callCampaignCode === 'N17' || this.callCampaignCode === 'TS4' || this.callCampaignCode === 'J04') {
        this.campaignService.scriptName = 'ush-e17';
      } else if (this.callCampaignCode === 'E15' || this.callCampaignCode === 'K15' || this.callCampaignCode === 'N15' || this.callCampaignCode === 'J02') {
        this.campaignService.scriptName = 'ush-e15';
      }
    } else if (this.isPortmoreCall) {
      //*check if the call is for spanish skill code
      if (this.isPortmoreSpanishCall) {
        this.campaignService.scriptName = 'default-spanish';
      } else {
        this.campaignService.scriptName = 'default';
      }
    }
    //* Default Spanish OR Default English
    else if (this.isDefaultSpanish) {
      this.campaignService.scriptName = 'default-spanish';
    }
    //* Default Spanish OR Default English
    else if (this.isDefaultEnglish) {
      this.campaignService.scriptName = 'default';
    } 
    else {
      this.campaignService.scriptName = 'default';
    }
  }

  setupPGECall(btn: any, campaignCode: any) {
    //load Pge Spanish script if code matches
    this.isPGESpanishCall = this.campaignService.getScriptSkillCode('PGESPANISHSKILLCODE').includes(campaignCode);
    //get PGE data
    this.bdService.getCustomerDataFromBD(btn, 'PGE');
    //setPGE Fields Validations
    this.campaignService.greetingForm.controls['utlitityConfirmationEmail'].setValidators([
      Validators.required,
      Validators.email,
    ]);
    this.campaignService.greetingForm.controls['utlitityConfirmationEmail'].updateValueAndValidity();
  }

  setupUSHCall(btn: any, campaignCode: any) {
    this.resetResidentTypeToEmpty();
    this.campaignService.greetingForm.controls['isConfirmPhoneNumber'].setValue(false);
    // get FE data
    this.bdService.getCustomerDataFromBD(btn, 'FE');
  }

  setupPortmoreCall(btn: any, campaignCode: any) {
    this.resetResidentTypeToEmpty();
    this.campaignService.greetingForm.controls['isConfirmPhoneNumber'].setValue(false);
    // get FE data
    //this.bdService.getCustomerDataFromBD(btn, 'FE');
  }

  setupStarLinkCall() {
    //* If Starlink call reduce steps to 1
    this.campaignService.steps = this.campaignService.stepsConstants.slice(0, 1);
    //* Add Validation for star link accountType for starLink Call
    this.campaignService.greetingForm.controls['accountType'].setValidators([Validators.required]);
    // Trigger a revalidation to apply the new validator
    this.campaignService.greetingForm.controls['accountType'].updateValueAndValidity();
  }
  setupStarlinkInboundCall() {
    this.campaignService.steps = this.campaignService.starlinkInboundSteps;
  }
  
  setupZiplyCall() {
    //* If Ziply call reduce steps to 2 --greetings and address
    this.campaignService.steps = this.campaignService.stepsConstants.slice(0, 2);
    //* Add Validation for star link accountType for Ziply Call
    //this.campaignService.greetingForm.controls['utlitityConfirmationEmail'].setValidators([Validators.required]);
    // this.campaignService.greetingForm.controls['meetingSource'].setValidators([Validators.required]);
    //this.campaignService.greetingForm.controls['primaryInterest'].setValidators([Validators.required]);
    //this.campaignService.greetingForm.controls['currentProvider'].setValidators([Validators.required]);
    //this.campaignService.greetingForm.controls['companyName'].setValidators([Validators.required]);
    //this.campaignService.greetingForm.controls['jobTitle'].setValidators([Validators.required]);

    // Trigger a revalidation to apply the new validator
    // this.campaignService.greetingForm.controls['utlitityConfirmationEmail'].updateValueAndValidity();
    //  this.campaignService.greetingForm.controls['meetingSource'].updateValueAndValidity();
    // this.campaignService.greetingForm.controls['primaryInterest'].updateValueAndValidity();
    // this.campaignService.greetingForm.controls['currentProvider'].updateValueAndValidity();
    // this.campaignService.greetingForm.controls['companyName'].updateValueAndValidity();
    // this.campaignService.greetingForm.controls['jobTitle'].updateValueAndValidity();
  }

  setupPKCall(btn: any, campaignCode: any) {
    this.resetResidentTypeToEmpty();
  }

  resetResidentTypeToEmpty() {
    this.campaignService.addressForm.controls['residentType'].setValue('');
    this.campaignService.addressForm.controls['residentType'].setValidators([Validators.required]);
    // Trigger a revalidation to apply the new validator
    this.campaignService.addressForm.controls['residentType'].updateValueAndValidity();
  }

  //* Remove Any Subscriptions HERE
  ngOnDestroy(): void {
    this.subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  async setProviderData(campaign: any) {
    let data: any = {};
    let url = '';
    this.integration.isEnabled = campaign.Integration.IsEnabled;
    this.integration.isHubspotEnabled = campaign.Integration.IsHubspotEnabled;

    this.isStarlinkCampaign = this.campaignService.getScriptSkillCode('STAR_LINK_SKILLCODE').includes(campaign.Code);
    this.isZIPLYCampaign = (this.campaignService.getScriptSkillCode('ZIPLY_SKILLCODE') || '').includes(campaign.Code);

    if (this.isStarlinkCampaign) {
      url = `${Constants.INTEGRATION.HUBSPOT.GET_METADATA}`;
    } else if (this.isZIPLYCampaign) {
      url = `${Constants.INTEGRATION.SALEFORCE.GET_METADATA}`;
    }
    else if (this.isTikTokCampaign) {
      url = `${Constants.INTEGRATION.TIKTOK.GET_METADATA}`;
    }
    if(url) {
      data = await lastValueFrom(this.httpClient.get(url));
    }
    this.metadata$.next(data);
    this.campaignService.setProviderData(data);
  }

  setupLeadData(data: any, leadSource: string) {
    let {
      Message,
      AgentQuestions,
      AccountType,
      FirstName,
      LastName,
      Email,
      MeetingSource,
      MeetingStartDate,
      PrimaryInterest,
      Provider,
      Company,
      JobTitle,
      AccountOwner,
      Address,
      City,
      State,
      ZipCode,
      Description,
    } = data;
    let questions = JSON.parse(AgentQuestions || '[]');
    if (FirstName) FirstName = FirstName.trim();
    if (LastName) LastName = LastName.trim();
    this.campaignService.greetingForm.controls['firstName'].setValue(FirstName);
    this.campaignService.greetingForm.controls['lastName'].setValue(LastName);
    this.campaignService.addressForm.controls['email'].setValue(Email);
    switch (leadSource) {
      case LEADSOURCE.HUBSPOT:
        this.campaignService.greetingForm.controls['accountType'].setValue(AccountType || '');
        this.campaignService.message = Message;
        if (questions.length > 0) {
          //* if we have questions/answered data then clean questions array
          //* and  add the answered question to it.
          this.campaignService.questionsAnsweres.clear();
          for (var i = 0; i < questions.length; i++) {
            if (this.campaignService.questionsAnsweres.value.length < 5) {
              this.campaignService.questionsAnsweres.push(
                this.campaignService.createQuestionsAnsweresFormGroupWithData(
                  questions[i].question,
                  questions[i].answer
                )
              );
            }
          }
        }
        break;
      case LEADSOURCE.ZIPLY:
        MeetingSource && this.campaignService.greetingForm.controls['meetingSource'].setValue(MeetingSource);
        PrimaryInterest && this.campaignService.greetingForm.controls['primaryInterest'].setValue(PrimaryInterest);
        Provider && this.campaignService.greetingForm.controls['currentProvider'].setValue(Provider);
        Company && this.campaignService.greetingForm.controls['companyName'].setValue(Company);
        JobTitle && this.campaignService.greetingForm.controls['jobTitle'].setValue(JobTitle);
        AccountOwner && this.campaignService.greetingForm.controls['accountOwner'].setValue(AccountOwner);
        Email && this.campaignService.greetingForm.controls['utlitityConfirmationEmail'].setValue(Email);
        Address && this.campaignService.addressForm.controls['address'].setValue(Address);
        City && this.campaignService.addressForm.controls['city'].setValue(City);
        State && this.campaignService.addressForm.controls['state'].setValue(State);
        ZipCode && this.campaignService.addressForm.controls['zip'].setValue(ZipCode);
        Description && this.campaignService.greetingForm.controls['description'].setValue(Description);
        break;
    }
  }

  resetProviderBits() {
    //Provider bits
    this.isPGECall = false;
    this.isPGESpanishCall = false;
    this.isFPL_NRG_Call = false;
    this.isFPL_ENG_Call = false;
    this.isSTAR_LINK_Call = false;
    this.isZIPLY_Call = false;
    this.isStarlinkCampaign = false;
    this.isZIPLYCampaign = false;
    this.isUSH_Call = false;
    this.isPortmoreCall = false;
    this.isPortmoreSpanishCall = false;
    this.isPKCall = false;
    this.isDefaultSpanish = false;
    this.isDefaultEnglish = false;
    this.callCampaignCode = '';
  }
}
